import type { RouteLocationNormalized } from 'vue-router';

/**
 * TODO: Comment
 */
export default function useListings(route?: RouteLocationNormalized) {
    const { product } = useProduct(route);
    const { locale } = useNuxtApp().$i18n;

    /**
     * Load listing
     *
     */
    async function applyListing() {
        // If no listing or listing is already loaded for the current locale, we dont need to load it again
        if (!product.value.listingId || product.value.status.listingLocale === locale.value) {
            return;
        }

        const listing = (await apiLoadListing<Listing>(product.value.listingId)).data;

        applyConfig(listing);
        applyContent(listing);
    }

    /**
     *
     */
    function applyConfig(listing: Listing) {
        // TODO
        product.value.status.listingLocale = locale.value;
    }

    /**
     *
     */
    function applyContent(listing: Listing) {
        product.value.content.common ??= {};
        product.value.content.common.productName = listing.title;

        if (product.value.config.type === 'P2P') {
            const listingP2P = listing as ListingP2P;
            product.value.content.p2p = {
                map: listingP2P.media.map,
                journeyDestination: listingP2P.media.journeyDestination,
            };
        }
    }

    return {
        applyListing,
    };
}
